export function registerMoveEvent(node, leftSwipe, rightSwipe) {
  node.addEventListener("touchstart", handleTouchStart, { passive: true });
  node.addEventListener("touchmove", handleTouchMove, { passive: true });

  let xDown = null;
  let yDown = null;

  const getTouches = (e) => e.touches || e.originalEvent.touches;

  function handleTouchStart(evt) {
    const firstTouch = getTouches(evt)[0];
    xDown = firstTouch.clientX;
    yDown = firstTouch.clientY;
  }

  function handleTouchMove(evt) {
    if (!xDown || !yDown) {
      return;
    }

    let xUp = evt.touches[0].clientX;
    let yUp = evt.touches[0].clientY;

    let xDiff = xDown - xUp;
    let yDiff = yDown - yUp;

    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      if (xDiff > 0) {
        leftSwipe();
      } else {
        rightSwipe();
      }
    }
    xDown = null;
    yDown = null;
  }
}
